import { api } from "jiffy-api";
import { hasConsentedToSocialMediaConversion } from "common/utils/ui/iub-consent-utils";
import { notifyError } from "common/utils/app-monitoring/notify";

const $getOrderNumber = () => document.querySelector(".js-order-number-container");

const sendServerSideConversion = async (eventName, data) => {
  if (!hasConsentedToSocialMediaConversion()) {
    return;
  }

  try {
    const payload = {
      event_id: data.event_id,
      order_number: data.order_number ?? $getOrderNumber()?.dataset?.orderNumber,
      event_name: eventName,
      source_url: window.location.href,
      value: data.event_value
    };

    if (data.product_id != null) {
      payload.product_id = data.product_id;
    }
    if (data.composition_id != null) {
      payload.composition_id = data.composition_id;
    }

    await api.product.sendSocialMediaConversionApi(payload);
  } catch (error) {
    notifyError(`Error sending ${eventName} conversion event`, { context: { error } });
  }
};

export default sendServerSideConversion;
